import type { SyntaxNode } from 'web-tree-sitter';
import type { SymbolImportBinding } from '../../types.js';
import { pushBinding, stringLiteralText } from './shared.js';

function collectImportSpec(
  out: SymbolImportBinding[],
  filePath: string,
  workspaceFiles: ReadonlySet<string>,
  spec: SyntaxNode,
): void {
  const pathNode = spec.childForFieldName('path');
  if (!pathNode) return;
  const modulePath = stringLiteralText(pathNode);

  const nameNode = spec.childForFieldName('name');
  if (nameNode) {
    pushBinding(out, filePath, workspaceFiles, modulePath, nameNode.text, nameNode.text, 'namespace', nameNode);
    return;
  }

  const localName = modulePath.split('/').filter(Boolean).at(-1) ?? modulePath;
  pushBinding(out, filePath, workspaceFiles, modulePath, localName, localName, 'namespace', pathNode);
}

export function extractGoImportBindings(
  root: SyntaxNode,
  filePath: string,
  workspaceFiles: ReadonlySet<string>,
): SymbolImportBinding[] {
  const out: SymbolImportBinding[] = [];
  for (const node of root.descendantsOfType('import_declaration')) {
    for (const spec of node.descendantsOfType('import_spec')) {
      collectImportSpec(out, filePath, workspaceFiles, spec);
    }
  }
  return out;
}
